import { FormattedMessage } from 'react-intl';
import { FractionDigitsFormattedNumber } from '@synergy/components-next';
import { ReactElement } from 'react';
import { Stack } from '@mui/material';

import { VerticalDivider } from '../../../components/vertical-divider/vertical-divider';
import { useArticleDetailContext } from '../article-detail';

export const ArticleDetailPriceContainerDetailPricesPerQuantity = (): ReactElement | null => {
    const { article } = useArticleDetailContext();
    const {
        contentUnit,
        mainPrice,
        specialPrice,
        currency,
        contentQuantity,
        priceQuantity,
        orderUnit,
        priceReferenceQuantity,
    } = article;

    const calcPrice = specialPrice?.price ?? mainPrice;

    return (
        <Stack
            direction="row"
            gap={1}
            rowGap={0.5}
            color="grey.800"
            typography="body2"
            divider={<VerticalDivider />}
            flexWrap="wrap"
        >
            <FormattedMessage id="app.article.detail.exclusiveTaxes" />

            {priceQuantity && priceQuantity > 1 && (
                <FormattedMessage
                    id="app.article.detail.per"
                    values={{
                        price: <FractionDigitsFormattedNumber value={calcPrice} currency={currency} />,
                        quantity: null,
                        unit: orderUnit,
                    }}
                />
            )}

            {contentQuantity && contentQuantity > 1 && (
                <FormattedMessage
                    id="app.article.detail.per"
                    values={{
                        price: (
                            <FractionDigitsFormattedNumber value={calcPrice / contentQuantity} currency={currency} />
                        ),
                        quantity: null,
                        unit: contentUnit,
                    }}
                />
            )}

            {contentQuantity && priceReferenceQuantity && priceReferenceQuantity > 1 && (
                <FormattedMessage
                    id="app.article.detail.per"
                    values={{
                        price: (
                            <FractionDigitsFormattedNumber
                                value={(calcPrice / contentQuantity) * priceReferenceQuantity}
                                currency={currency}
                            />
                        ),
                        quantity: priceReferenceQuantity,
                        unit: contentUnit,
                    }}
                />
            )}
        </Stack>
    );
};
